import React, { useState, useEffect, useRef } from 'react';
import Layout from '../../Layout';
import { Select, Table } from 'antd'; // Import thêm Table từ antd
import { PhoneOff } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const mockCustomers = [
    { name: 'Cleo Tamuka', phone: '061412630385', address: 'Bắc Giang', agent: 'tp03', branch: 'Quận 2', service: 'Cấy tóc', callStatus: 'Gọi đến', color: 'bg-blue-500' },
    { name: 'Torben Strothenke', phone: '09876543214', address: 'Cà Mau', agent: 'tp03', branch: 'Trần Hưng Đạo', service: 'Làm đẹp da', callStatus: 'Gọi đi', color: 'bg-emerald-500' },
    { name: 'Tâm Anna', phone: '0912223344', address: 'Hà Nội', agent: 'Nguyễn Như Huệ', branch: 'Quận 2', service: 'Nâng mũi', callStatus: 'Gọi đến lỡ', color: 'bg-red-500' },
    { name: 'Hải Minh', phone: '0985588959', address: 'An Giang', agent: 'Trực page 02', branch: 'Trần Hưng Đạo', service: '', callStatus: 'Gọi đi lỡ', color: 'bg-orange-500' },
    { name: 'Tu Truong', phone: '0987654321', address: 'Bắc Ninh', agent: 'Trực page 02', branch: 'Quận 2', service: 'Cấy tóc', callStatus: 'Gọi đến', color: 'bg-blue-500' },
    { name: '', phone: '0933112233', address: '---', agent: 'Chưa phân công', branch: '---', service: '', callStatus: 'Số máy lạ', color: 'bg-gray-500' },
    { name: 'Lê Văn Đạt', phone: '0901234567', address: 'Đà Nẵng', agent: 'Telesale 1', branch: 'Quận 2', service: 'Cấy tóc', callStatus: 'Gọi đi', color: 'bg-purple-500' },
    { name: 'Nguyễn Minh Anh', phone: '0912345678', address: 'Hải Phòng', agent: 'Telesale 2', branch: 'Trần Hưng Đạo', service: 'Làm đẹp da', callStatus: 'Gọi đến', color: 'bg-teal-500' },
    { name: 'Trần Đức Bo', phone: '0988776655', address: 'TP.HCM', agent: 'tp03', branch: 'Quận 2', service: 'Nâng mũi', callStatus: 'Gọi đến lỡ', color: 'bg-indigo-500' },
    { name: 'Phạm Hương', phone: '0977665544', address: 'Bình Dương', agent: 'Nguyễn Như Huệ', branch: 'Trần Hưng Đạo', service: '', callStatus: 'Gọi đi lỡ', color: 'bg-pink-500' },
    { name: '', phone: '0355443322', address: '---', agent: 'Chưa phân công', branch: '---', service: '', callStatus: 'Số máy lạ', color: 'bg-gray-500' },
    { name: 'Đặng Ngọc', phone: '0966554433', address: 'Đồng Nai', agent: 'Trực page 02', branch: 'Quận 2', service: 'Cấy tóc', callStatus: 'Gọi đến', color: 'bg-blue-400' },
    { name: 'Bùi Tuấn', phone: '0944332211', address: 'Cần Thơ', agent: 'Telesale 1', branch: 'Trần Hưng Đạo', service: 'Làm đẹp da', callStatus: 'Gọi đi', color: 'bg-emerald-400' },
    { name: 'Vũ Hằng', phone: '0922110099', address: 'Khánh Hòa', agent: 'Telesale 2', branch: 'Quận 2', service: 'Nâng mũi', callStatus: 'Gọi đến lỡ', color: 'bg-red-400' },
    { name: 'Hoàng Oanh', phone: '0900998877', address: 'Vũng Tàu', agent: 'tp03', branch: 'Trần Hưng Đạo', service: '', callStatus: 'Gọi đi lỡ', color: 'bg-orange-400' },
    { name: '', phone: '0388776655', address: '---', agent: 'Chưa phân công', branch: '---', service: '', callStatus: 'Số máy lạ', color: 'bg-gray-500' },
    { name: 'Ngô Kiến', phone: '0366554433', address: 'Lâm Đồng', agent: 'Nguyễn Như Huệ', branch: 'Quận 2', service: 'Cấy tóc', callStatus: 'Gọi đi', color: 'bg-purple-400' },
    { name: 'Đỗ Hùng', phone: '0344332211', address: 'Bình Thuận', agent: 'Trực page 02', branch: 'Trần Hưng Đạo', service: 'Làm đẹp da', callStatus: 'Gọi đến', color: 'bg-teal-400' },
    { name: 'Lý Nhã', phone: '0322110099', address: 'Nghệ An', agent: 'Telesale 1', branch: 'Quận 2', service: 'Nâng mũi', callStatus: 'Gọi đến lỡ', color: 'bg-indigo-400' },
    { name: 'Thái Hòa', phone: '0300998877', address: 'Hà Tĩnh', agent: 'Telesale 2', branch: 'Trần Hưng Đạo', service: '', callStatus: 'Gọi đi lỡ', color: 'bg-pink-400' }
];

export default function App() {
    const navigate = useNavigate();
    const [currentView, setCurrentView] = useState('tickets');
    const [agentStatus, setAgentStatus] = useState({ state: 'ONLINE', colorClass: 'green' });
    const [isAgentMenuOpen, setIsAgentMenuOpen] = useState(false);

    // Softphone State
    const [isSoftphoneOpen, setIsSoftphoneOpen] = useState(false);
    const [dialerInput, setDialerInput] = useState('');
    const [callState, setCallState] = useState('idle');
    const [callingNumber, setCallingNumber] = useState('');
    const [callingName, setCallingName] = useState('');
    const [callDuration, setCallDuration] = useState(0);
    const [currentTicketContext, setCurrentTicketContext] = useState(null);
    const [callLogs, setCallLogs] = useState([]);

    // Detail View State
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [chatNoteModalData, setChatNoteModalData] = useState(null);
    const [toastMessage, setToastMessage] = useState(null);

    const callTimerRef = useRef(null);
    const agentMenuRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (agentMenuRef.current && !agentMenuRef.current.contains(event.target)) {
                setIsAgentMenuOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        if (callState === 'connected') {
            callTimerRef.current = setInterval(() => {
                setCallDuration((prev) => prev + 1);
            }, 1000);
        } else {
            clearInterval(callTimerRef.current);
            if (callState === 'idle') setCallDuration(0);
        }
        return () => clearInterval(callTimerRef.current);
    }, [callState]);

    const showToast = (message) => {
        setToastMessage(message);
        setTimeout(() => setToastMessage(null), 3000);
    };

    const handleMakeCall = (phone, name, ticketContext = null) => {
        setCurrentTicketContext(ticketContext);
        setIsSoftphoneOpen(true);
        setDialerInput(phone);
        handleStartCall(phone, name);
    };

    const handleStartCall = (phone, name) => {
        if (!phone) return;
        setCallingNumber(phone);
        setCallingName(name || 'Khách hàng');
        setCallState('calling');
        setTimeout(() => {
            setCallState('connected');
        }, 2000);
    };

    const handleEndCall = () => {
        setCallState('ended');
        const timeStr = new Date().toLocaleTimeString('vi-VN', { hour: '2-digit', minute: '2-digit' });
        const formatDuration = (seconds) => {
            const m = Math.floor(seconds / 60).toString().padStart(2, '0');
            const s = (seconds % 60).toString().padStart(2, '0');
            return `${m}:${s}`;
        };

        const newLog = {
            id: Date.now(),
            name: callingName,
            time: timeStr,
            duration: formatDuration(callDuration),
            ticketContext: currentTicketContext
        };

        setCallLogs(prev => [newLog, ...prev]);

        setTimeout(() => {
            setCallState('idle');
            setDialerInput('');
            setCurrentTicketContext(null);
        }, 1000);
    };

    const formatDurationDisplay = (seconds) => {
        const m = Math.floor(seconds / 60).toString().padStart(2, '0');
        const s = (seconds % 60).toString().padStart(2, '0');
        return `${m}:${s}`;
    };

    const Icons = {
        Users: () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"></path></svg>,
        Search: () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>,
        Phone: () => <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>,
        ArrowUp: () => <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 10l7-7m0 0l7 7m-7-7v18"></path></svg>,
        ArrowDown: () => <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path></svg>,
        PhoneMissed: () => <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 3l18 18M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>,
        PhoneOff: () => <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"></path></svg>,
        UserSecret: () => <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04l.054-.09A13.916 13.916 0 008 11a4 4 0 118 0c0 1.017-.07 2.019-.203 3m-2.118 6.844A21.88 21.88 0 0015.171 17m3.839 1.132c.645-2.266.99-4.659.99-7.132A8 8 0 008 4.07M3 15.364c.64-1.319 1-2.8 1-4.364 0-1.457.39-2.823 1.07-4"></path></svg>,
        Play: () => <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"></path><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>,
        ChatDots: () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path></svg>,
        Calendar: () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>,
        Headset: () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 11.696V10a8 8 0 10-16 0v1.696A4.001 4.001 0 003 15v3a2 2 0 002 2h1a2 2 0 002-2v-3a2 2 0 00-2-2v-1.696A5.98 5.98 0 0112 6a5.98 5.98 0 017 4.304V12a2 2 0 00-2 2v3a2 2 0 002 2h1a2 2 0 002-2v-3a4.001 4.001 0 00-1-3.304z"></path></svg>,
        Times: () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>,
        Backspace: () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M3 12l6.414 6.414a2 2 0 001.414.586H19a2 2 0 002-2V7a2 2 0 00-2-2h-8.172a2 2 0 00-1.414.586L3 12z"></path></svg>
    };

    const staffOptions = [
        { value: 1, label: "Nguyễn Văn A" },
        { value: 2, label: "Trần Văn B" },
    ];

    const DateOptions = [
        { value: 1, label: "Theo ngày" },
        { value: 2, label: "Theo tuần" },
        { value: 3, label: "Theo tháng" },
        { value: 4, label: "Theo năm" },
    ];

    // ĐỊNH NGHĨA CỘT CHO ANTD TABLE
    const columns = [
        {
            title: 'KHÁCH HÀNG',
            key: 'customer',
            width: 250,
            render: (_, record) => {
                const hasName = record.name.trim() !== '';
                const displayName = hasName ? record.name : 'Số máy lạ';
                const avatarChar = hasName ? record.name.charAt(0).toUpperCase() : <Icons.UserSecret />;
                return (
                    <div className="flex items-center gap-3 py-1">
                        <div className={`w-9 h-9 rounded-full ${record.color} text-white flex items-center justify-center font-bold text-sm shadow-sm`}>
                            {avatarChar}
                        </div>
                        <div>
                            <div
                                className={`font-semibold text-000000e0 group-hover:text-blue-600 transition ${hasName ? 'cursor-pointer' : ''}`}
                                onClick={() => {
                                    if (hasName) {
                                        setSelectedCustomer(record);
                                        navigate('/customer-demo/detail');
                                    }
                                }}
                            >
                                {displayName}
                            </div>
                            <div className="text-[13px] text-blue-500 font-medium">{record.phone}</div>
                        </div>
                    </div>
                );
            }
        },
        {
            title: 'TƯƠNG TÁC',
            key: 'action',
            align: 'center',
            width: 150,
            render: (_, record) => {
                const hasName = record.name.trim() !== '';
                const displayName = hasName ? record.name : 'Số máy lạ';
                const disableAudio = record.callStatus.includes('lỡ');
                return (
                    <div className="flex items-center justify-center gap-1.5">
                        <button onClick={() => handleMakeCall(record.phone, displayName)} className="w-7 h-7 rounded-full bg-green-50 text-green-600 flex items-center justify-center hover:bg-green-100 transition" title="Gọi điện">
                            <Icons.Phone />
                        </button>
                        <button className={`w-7 h-7 rounded-full bg-gray-50 flex items-center justify-center transition ${disableAudio ? 'opacity-30 cursor-not-allowed text-gray-400' : 'hover:bg-blue-100 hover:text-blue-600 text-gray-400 cursor-pointer'}`} title={disableAudio ? 'Không có ghi âm' : 'Nghe ghi âm'}>
                            <Icons.Play />
                        </button>
                        <button onClick={() => setChatNoteModalData(displayName)} className="w-7 h-7 rounded-full bg-gray-50 text-gray-400 flex items-center justify-center hover:bg-blue-100 hover:text-blue-600 transition" title="Xem ghi chú / Chat">
                            <Icons.ChatDots />
                        </button>
                    </div>
                );
            }
        },
        {
            title: 'ĐỊA CHỈ',
            dataIndex: 'address',
            key: 'address',
            render: (text) => <span className="text-[13px] text-000000e0">{text}</span>
        },
        {
            title: 'NHÂN VIÊN PHỤ TRÁCH',
            dataIndex: 'agent',
            key: 'agent',
            render: (text) => (
                <div className="flex items-center gap-2">
                    <div className="w-5 h-5 rounded-full bg-purple-100 text-purple-600 flex items-center justify-center font-bold text-[9px]">{text.charAt(0).toUpperCase()}</div>
                    <span className="text-[13px] text-000000e0">{text}</span>
                </div>
            )
        },
        {
            title: 'CHI NHÁNH',
            dataIndex: 'branch',
            key: 'branch',
            render: (text) => <span className="text-[13px] text-000000e0 font-medium">{text}</span>
        },
        {
            title: 'DỊCH VỤ',
            dataIndex: 'service',
            key: 'service',
            render: (text) => (
                text ?
                    <span className="px-2 py-1 bg-pink-50 text-pink-600 rounded text-xs font-medium border border-pink-100">{text}</span> :
                    <span className="px-2 py-1 bg-gray-50 text-gray-400 rounded text-xs border border-gray-200">Chưa có dịch vụ</span>
            )
        },
        {
            title: 'TRẠNG THÁI CUỘC GỌI',
            dataIndex: 'callStatus',
            key: 'callStatus',
            render: (status) => {
                if (status === 'Gọi đến') return <span className="text-blue-600 bg-blue-50 px-2 py-1 rounded text-[11px] font-medium border border-blue-100 flex items-center gap-1 w-max"><Icons.ArrowDown /> Gọi đến</span>;
                if (status === 'Gọi đi') return <span className="text-emerald-600 bg-emerald-50 px-2 py-1 rounded text-[11px] font-medium border border-emerald-100 flex items-center gap-1 w-max"><Icons.ArrowUp /> Gọi đi</span>;
                if (status === 'Gọi đến lỡ') return <span className="text-red-600 bg-red-50 px-2 py-1 rounded text-[11px] font-medium border border-red-100 flex items-center gap-1 w-max"><Icons.PhoneMissed /> Gọi đến lỡ</span>;
                if (status === 'Gọi đi lỡ') return <span className="text-orange-600 bg-orange-50 px-2 py-1 rounded text-[11px] font-medium border border-orange-100 flex items-center gap-1 w-max"><Icons.PhoneOff /> Gọi đi lỡ</span>;
                if (status === 'Số máy lạ') return <span className="text-000000e0 bg-gray-100 px-2 py-1 rounded text-[11px] font-medium border border-gray-200 flex items-center gap-1 w-max"><Icons.UserSecret /> Số máy lạ</span>;
                return status;
            }
        }
    ];

    return (
        <Layout>
            <div className="flex-1 flex flex-col min-w-0 relative">
                {/* Main Content Area */}
                <div className="flex items-center gap-4">
                    <h1 className="text-lg font-semibold text-000000e0">
                        CRM Khách hàng
                    </h1>
                </div>
                <div className="flex-1 flex overflow-hidden relative">
                    <div className="flex-1 flex flex-col overflow-y-auto w-full">
                        <div className="py-4 border-b border-gray-200">
                            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-4">
                                <div className="flex-wrap flex items-center gap-3 flex-1">
                                    <div className="relative w-64 shrink-0">
                                        <span className="absolute left-3 top-2.5 text-gray-400"><Icons.Search /></span>
                                        <input type="text" placeholder="Tìm tên, sđt khách hàng" className="w-full pl-9 pr-4 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-blue-500 bg-gray-50 focus:bg-white transition shadow-sm" />
                                    </div>
                                    <div className="border border-gray-300 rounded-md px-3 h-[38px] text-sm text-000000e0 bg-white flex items-center cursor-pointer hover:bg-gray-50 shadow-sm shrink-0 dark:bg-[#374151] dark:border-[#4B5563] dark:text-gray-300 dark:hover:bg-[#374151] w-full md:w-[220px]">
                                        <div className="w-4 h-4 text-gray-400 shrink-0 flex items-center justify-center">
                                            <Icons.Users />
                                        </div>
                                        <Select
                                            bordered={false}
                                            placeholder="Chọn người phụ trách"
                                            className="w-full"
                                            allowClear
                                            showSearch
                                            optionFilterProp="label"
                                            options={staffOptions}
                                        />
                                    </div>
                                    <div className="border border-gray-300 rounded-md px-3 h-[38px] text-sm text-000000e0 bg-white flex items-center cursor-pointer hover:bg-gray-50 shadow-sm shrink-0 dark:bg-[#374151] dark:border-[#4B5563] dark:text-gray-300 dark:hover:bg-[#374151] w-full md:w-[220px]">
                                        <div className="w-4 h-4 text-gray-400 shrink-0 flex items-center justify-center">
                                            <Icons.Calendar />
                                        </div>
                                        <Select
                                            bordered={false}
                                            placeholder="Theo ngày"
                                            className="w-full"
                                            allowClear
                                            showSearch
                                            optionFilterProp="label"
                                            options={DateOptions}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="flex items-center gap-2 overflow-x-auto pb-1 scrollbar-hide">
                                <button className="px-4 py-1.5 rounded-full text-[13px] font-medium bg-gray-800 text-white shrink-0">Tất cả cuộc gọi</button>
                                <button className="px-4 py-1.5 rounded-full text-[13px] font-medium bg-emerald-50 text-emerald-700 border border-emerald-200 hover:bg-emerald-100 shrink-0 flex items-center gap-1.5"><Icons.ArrowUp /> Gọi đi</button>
                                <button className="px-4 py-1.5 rounded-full text-[13px] font-medium bg-blue-50 text-blue-700 border border-blue-200 hover:bg-blue-100 shrink-0 flex items-center gap-1.5"><Icons.ArrowDown /> Gọi đến</button>
                                <button className="px-4 py-1.5 rounded-full text-[13px] font-medium bg-red-50 text-red-700 border border-red-200 hover:bg-red-100 shrink-0 flex items-center gap-1.5"><Icons.PhoneMissed /> Gọi đến lỡ</button>
                                <button className="px-4 py-1.5 rounded-full text-[13px] font-medium bg-orange-50 text-orange-700 border border-orange-200 hover:bg-orange-100 shrink-0 flex items-center gap-1.5"><Icons.PhoneOff /> Gọi đi lỡ</button>
                                <button className="px-4 py-1.5 rounded-full text-[13px] font-medium bg-gray-100 text-000000e0 border border-gray-300 hover:bg-gray-200 shrink-0 flex items-center gap-1.5"><Icons.UserSecret /> Số máy lạ</button>
                            </div>
                        </div>

                        {/* Ant Design Table Section */}
                        <div className="flex-1 py-6">
                            <div className="">
                                <Table
                                    columns={columns}
                                    dataSource={mockCustomers}
                                    rowKey={(record, index) => record.phone + index}
                                    scroll={{ x: "max-content" }}
                                    rowClassName={() => "group cursor-default hover:bg-blue-50/30 transition"}
                                    className="custom-ant-table"
                                    pagination={{
                                        pageSize: 10,
                                        showSizeChanger: true,
                                        showTotal: (total, range) => `Hiển thị ${range[0]} đến ${range[1]} của ${total} khách hàng`
                                    }}
                                />
                            </div>
                        </div>
                        {/* Kết thúc Ant Design Table Section */}
                    </div>
                </div>

                {/* Softphone Modal */}
                <div className={`fixed bottom-6 right-6 w-72 bg-white rounded-xl shadow-[0_10px_40px_-10px_rgba(0,0,0,0.3)] border border-gray-200 z-50 transition-transform duration-300 transform flex flex-col overflow-hidden ${isSoftphoneOpen ? 'translate-y-0' : 'translate-y-[120%]'}`}>
                    <div className="bg-gray-900 text-white p-3 flex justify-between items-center cursor-move">
                        <div className="flex items-center gap-2">
                            <span className="text-blue-400"><Icons.Headset /></span>
                            <span className="font-semibold text-sm">MiCall Extension</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className={`w-2 h-2 rounded-full bg-${agentStatus.colorClass === 'gray' ? 'red' : 'green'}-500`}></div>
                            <button onClick={() => setIsSoftphoneOpen(false)} className="text-gray-400 hover:text-white"><Icons.Times /></button>
                        </div>
                    </div>

                    {callState === 'idle' ? (
                        <div className="p-4 flex flex-col items-center">
                            <input type="text" value={dialerInput} onChange={(e) => setDialerInput(e.target.value)} placeholder="Nhập số điện thoại..." className="w-full text-center text-lg font-bold text-000000e0 border-b-2 border-gray-200 focus:border-blue-500 focus:outline-none pb-2 mb-4 bg-transparent" />

                            <div className="grid grid-cols-3 gap-3 w-full px-2 mb-4">
                                {['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0'].map(num => (
                                    <button key={num} onClick={() => setDialerInput(prev => prev + num)} className="h-10 rounded bg-gray-100 hover:bg-gray-200 font-semibold text-000000e0">{num}</button>
                                ))}
                                <button onClick={() => setDialerInput(prev => prev.slice(0, -1))} className="h-10 rounded bg-gray-100 hover:bg-gray-200 text-000000e0 flex items-center justify-center"><Icons.Backspace /></button>
                            </div>
                            <button onClick={() => handleStartCall(dialerInput, 'Không xác định')} className="w-12 h-12 rounded-full bg-green-500 hover:bg-green-600 text-white flex items-center justify-center text-xl shadow transition transform hover:scale-105">
                                <Icons.Phone />
                            </button>
                        </div>
                    ) : (
                        <div className="p-6 flex flex-col items-center bg-gray-900 text-white relative">
                            {callState === 'calling' && (
                                <div className="absolute inset-0 opacity-20 pointer-events-none flex items-center justify-center">
                                    <div className="w-32 h-32 rounded-full border-2 border-green-500 pulse-ring"></div>
                                </div>
                            )}
                            <h4 className="text-gray-400 text-xs mb-1 z-10">
                                {callState === 'calling' ? 'Đang kết nối...' : callState === 'connected' ? 'Đang đàm thoại' : 'Đã kết thúc'}
                            </h4>
                            <h2 className="text-xl font-bold mb-1 z-10">{callingNumber}</h2>
                            <p className="text-xs text-gray-300 mb-4 z-10">{callingName}</p>
                            <div className="w-32 h-32 rounded-full border-2 border-green-500 pulse-ring flex items-center justify-center mb-4 relative">
                                <div className={`text-2xl font-mono z-10 ${callState === 'connected' ? 'text-green-400' : 'text-gray-500'}`}>
                                    {formatDurationDisplay(callDuration)}
                                </div>
                            </div>
                            <button onClick={handleEndCall} disabled={callState === 'ended'} className={`w-12 h-12 rounded-full flex items-center justify-center text-xl shadow transition z-10 ${callState === 'ended' ? 'bg-gray-600 cursor-not-allowed' : 'bg-red-500 hover:bg-red-600 hover:scale-105'}`}>
                                <PhoneOff size={20} color="#fff" />
                            </button>
                        </div>
                    )}
                </div>

                {/* Chat Note Modal */}
                {chatNoteModalData && (
                    <div className="fixed inset-0 bg-gray-900/40 z-[100] flex items-center justify-center">
                        <div className="bg-white rounded-lg shadow-xl w-[400px] overflow-hidden flex flex-col transform transition-all">
                            <div className="px-4 py-3 border-b border-gray-100 flex justify-between items-center bg-gray-50">
                                <h3 className="font-semibold text-gray-800 flex items-center gap-2"><span className="text-blue-500"><Icons.ChatDots /></span> Ghi chú / Chat gần nhất</h3>
                                <button onClick={() => setChatNoteModalData(null)} className="text-gray-400 hover:text-000000e0"><Icons.Times /></button>
                            </div>
                            <div className="p-4 text-sm text-000000e0">
                                <p className="font-medium text-000000e0 mb-2">{chatNoteModalData}</p>
                                <div className="bg-yellow-50 border border-yellow-100 rounded p-3 mb-3 text-000000e0 shadow-inner">
                                    Khách hàng quan tâm dịch vụ cấy tóc và làm đẹp da, cần tư vấn thêm về liệu trình. Hẹn gọi lại vào chiều mai.
                                </div>
                                <div className="flex justify-between items-center text-[11px] text-gray-400">
                                    <span>Người tạo: tp03</span>
                                    <span>14:30 - 21/07/2026</span>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </Layout>
    );
}